import NewsItemContainer from "./styles";
export default NewsItemContainer;
